import React, { Component } from "react";
import { connect } from "react-redux";
import { getTranslate } from "react-localize-redux";
import { Nav, NavItem } from "reactstrap";
import { Switch, NavLink } from "react-router-dom";
import { actions } from "react-redux-form";

import { ExecReports } from "./executedReports/ExecReports";
import { ConfigReports } from "./configuredReports/ConfigReports";
import { getConfiguredReportsParams } from "../../../utils";
import { reportActions } from "../../../redux/actions";
import { PrivateRoute } from "../../../components";

class Reports extends Component {
  componentDidMount() {
    const {
      dispatch,
      errorConfigReports,
      loadingConfigReports,
      loadedConfigReports,
      isSubUser,
      subUser,
    } = this.props;

    if (
      isSubUser &&
      !errorConfigReports &&
      !loadingConfigReports &&
      !loadedConfigReports
    ) {
      dispatch(actions.change("configReportSearch.PageNumber", 1));
      dispatch(
        reportActions.getConfiguredReports(
          getConfiguredReportsParams(
            { ...this.props.configReportSearch, PageNumber: 1 },
            isSubUser,
            subUser ? subUser.customerGlobalId : null
          )
        )
      );
    }
  }

  render() {
    const { translate, user, isSubUser, subUser } = this.props;
    let currentUser = user;
    if (isSubUser) {
      currentUser = subUser;
    }
    const { pageItemCount } = currentUser || {};

    return (
      <div id="reports">
        <div
          className="content_block fill col-lg-12 col-md-12 col-sm-12 col-xs-12"
          style={{
            padding: "0",
            width: "100%",
            background: "rgb(218, 215, 203)",
          }}
        >
          <Nav tabs>
            <NavItem>
              <NavLink
                to="/exec-reports"
                activeClassName="active"
                className="nav-link"
                style={{ position: "relative" }}
              >
                {translate("ExecutedReports")}
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                to="/config-reports"
                activeClassName="active"
                className="nav-link"
                style={{ position: "relative" }}
              >
                {translate("ConfiguredReports")}
              </NavLink>
            </NavItem>
          </Nav>
          <div>
            <Switch>
              <PrivateRoute
                exact
                path="/exec-reports"
                component={() => (
                  <ExecReports
                    isExternalUser={isSubUser}
                    externalCustomerId={
                      subUser ? subUser.customerGlobalId : null
                    }
                    defaultSize={pageItemCount}
                  />
                )}
              />
              <PrivateRoute
                exact
                path="/config-reports"
                component={() => (
                  <ConfigReports
                    isExternalUser={isSubUser}
                    externalCustomerId={
                      subUser ? subUser.customerGlobalId : null
                    }
                    defaultSize={pageItemCount}
                  />
                )}
              />
            </Switch>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const {
    reports: { errorConfigReports, loadingConfigReports, loadedConfigReports },
    locale,
    authentication: { user, isSubUser, subUser },
  } = state;
  return {
    errorConfigReports,
    loadingConfigReports,
    loadedConfigReports,
    user,
    isSubUser,
    subUser,
    translate: getTranslate(locale),
  };
}

const connectedReports = connect(mapStateToProps)(Reports);
export { connectedReports as Reports };
